import { useTypedTranslation } from 'translations/typedTranslations';
import i18n from 'i18n';
import { useEffect } from 'react';
import LoginRight from '../../../assets/Login-right-n.png';

const RightPanel = () => {
	const { t } = useTypedTranslation();

	const changeToBrowserLanguage = () => {
		const browserLanguage = navigator.language;
		const isEnglishLanguage = browserLanguage.startsWith('en');

		const languageToUse = isEnglishLanguage ? 'en-CL' : 'es-CL';
		i18n.changeLanguage(languageToUse);
		localStorage.setItem('lng', `${languageToUse}-login`);
	};

	useEffect(() => {
		changeToBrowserLanguage();
	}, []);

	return (
		<div className="bg-swarm-blue h-full ">
			<img src={LoginRight} alt="login-right" className="m-auto mt-14 w-10/12" />
			<h2 className="text-center text-4xl mt-5 text-swarm-pink font-bold">{t('ComoTransformarMundo')}</h2>

			<p className="text-center m-10 text-white">
				{t('IntroSwarmob1')} <span className="text-swarm-pink font-bold">{t('IntroSwarmob2')}</span>
				{t('IntroSwarmob3')}
			</p>
		</div>
	);
};

export default RightPanel;
